"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pipeline = void 0;
class Pipeline {
    constructor(terminal) {
        this._middlewares = [];
        this._terminalFunc = terminal || ((input) => Promise.resolve(input));
    }
    async execute(input) {
        // build chain of functions call, from lates in pipe to first
        const funcsChain = this._middlewares.reduceRight((prev, current) => (input) => current(input, prev), this._terminalFunc);
        const result = await funcsChain(input);
        return result;
    }
    use(middleware) {
        this._middlewares.push(middleware);
    }
}
exports.Pipeline = Pipeline;
//# sourceMappingURL=Pipeline.js.map